import React, { useState, useEffect } from 'react';
import Sidebar_Progress from "../../../layouts/Admin_Sidebar_Progress.component";
import LoginHeaderOperational from '../../LoginHeaderOperational';
import { API_URL } from "../../../../constant/API_Settings";
import { fetchPlatformSuperAdminProfile } from '../../../../utils/platformAuth';
import swal from "sweetalert";
import { Link, useHistory } from 'react-router-dom';
import { fetchAdminPumps, fetchPumpInvoiceSettings, savePumpInvoiceSettings } from '../adminApi';
import InvoiceSettingsFormFields from '../../shared/InvoiceSettingsFormFields';
import {
  DEFAULT_INVOICE_SETTINGS,
  applyInvoiceFieldUpdates,
  mapInvoiceSettingsFromApi,
  syncInvoiceGstFields,
  validateInvoiceSettings,
} from '../../../../utils/invoiceSettingsForm';
import '../admin-dashboard.css';

const AdminInvoiceSettings = (props) => {
  const history = useHistory();
  const [pumps, setPumps] = useState([]);
  const [pumpId, setPumpId] = useState(localStorage.getItem('admin_pump_id') || '');
  const [inputValues, setInputValues] = useState(DEFAULT_INVOICE_SETTINGS);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPlatformSuperAdminProfile(API_URL, localStorage.getItem('AUTH_TOKEN'))
      .then((profile) => {
        if (profile) fetchAdminPumps('', 1).then((res) => setPumps(res.data || []));
        else history.goBack();
      })
      .catch(() => history.goBack());
  }, [history]);

  useEffect(() => {
    if (pumpId) loadInvoiceSettings(pumpId);
  }, [pumpId]);

  const loadInvoiceSettings = (id) => {
    setLoading(true);
    fetchPumpInvoiceSettings(id)
      .then((data) => {
        if (data.status) {
          setInputValues(mapInvoiceSettingsFromApi(data.data));
          setErrors({});
        }
      })
      .finally(() => setLoading(false));
  };

  const handleFieldChange = (nameOrPatch, value) => {
    setInputValues((prev) => applyInvoiceFieldUpdates(prev, nameOrPatch, value));
    setErrors((prev) => {
      if (nameOrPatch && typeof nameOrPatch === 'object' && !Array.isArray(nameOrPatch)) {
        const next = { ...prev };
        Object.keys(nameOrPatch).forEach((key) => {
          next[key] = null;
        });
        return next;
      }
      return { ...prev, [nameOrPatch]: null };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!pumpId) {
      swal('Select pump', 'Choose a pump first', 'warning');
      return;
    }

    const synced = syncInvoiceGstFields(inputValues);
    setInputValues(synced);
    const validationErrors = validateInvoiceSettings(synced);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    savePumpInvoiceSettings(pumpId, synced)
      .then((data) => {
        if (data.status) swal("", "Saved successfully", "success");
        else swal("Error", data.message || "Save failed", "error");
      })
      .catch((err) => swal("Error", err.message, "error"));
  };

  return (
    <div className="main-container page-wrap admin-platform">
      <div className="d-md-flex">
        <Sidebar_Progress props={props} progress={28} />
        <div className="content-area">
          <LoginHeaderOperational props={props} page_title="Invoice Settings" />
          <div className="container pb-3 mt-3">
            <Link to="/admin_dashboard" className="small">← Control Center</Link>
            <div className="admin-panel mt-3 col-md-9">
              <h5>Per-pump invoice configuration</h5>
              <div className="mb-3">
                <label className="form-label">Select pump</label>
                <select className="form-select" value={pumpId} onChange={(e) => {
                  setPumpId(e.target.value);
                  localStorage.setItem('admin_pump_id', e.target.value);
                }}>
                  <option value="">Choose pump...</option>
                  {pumps.map((p) => (
                    <option key={p.id} value={p.id}>{p.pump_name}</option>
                  ))}
                </select>
              </div>

              {loading ? "Loading..." : pumpId ? (
                <form onSubmit={handleSubmit}>
                  <InvoiceSettingsFormFields
                    values={inputValues}
                    errors={errors}
                    onChange={handleFieldChange}
                  />
                  <button type="submit" className="btn btn-primary">Save</button>
                </form>
              ) : (
                <p className="text-muted">Select a pump to configure invoice settings.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminInvoiceSettings;
